import { Injectable } from '@angular/core';

import { Fixture, Option, OptionMarket } from '@cds/betting-offer';
import { BetBuilderFixture } from '@cds/betting-offer/domain-specific/bet-builder';
import { FixtureFactory } from '@frontend/sports/betting-offer/feature/fixture-factories';
import { EventModel } from '@frontend/sports/betting-offer/feature/model';
import { NativePrice } from '@frontend/sports/odds/feature/native-price';
import { MarqueeType } from '@frontend/sports/types/components/content';
import { flatten } from 'lodash-es';

import { BetBuilderTile, VisibilityOnMarquee } from '../../highlights-marquee/marquee-tile.model';
import { BetBuilderMarket, BetBuilderOption } from '../model/bet-builder.model';

@Injectable({ providedIn: 'root' })
export class PromotedBetBuilderService {
    constructor(private fixtureFactory: FixtureFactory) {}

    mapTiles(fixtures: BetBuilderFixture[]): BetBuilderTile[] | undefined {
        if (!fixtures || fixtures.length === 0 || fixtures.every((fixture) => !fixture.sourceFixture)) {
            return;
        }

        const promotedMarketTiles = fixtures.map((fixture) => {
            if (!fixture.sourceFixture) {
                return [];
            }

            return this.mapTilesForFixture(fixture.sourceFixture, fixture.sourceId);
        });

        return flatten(promotedMarketTiles);
    }

    private mapTilesForFixture(fixture: Fixture, sourceId: string): BetBuilderTile[] {
        const eventModel = this.fixtureFactory.create(fixture, sourceId);

        return fixture.optionMarkets.map((optionMarket) => {
            return this.mapTileForOptionMarket(eventModel, optionMarket, fixture.id);
        });
    }

    private mapTileForOptionMarket(eventModel: EventModel, optionMarket: OptionMarket, betBuilderFixtureId: string): BetBuilderTile {
        return {
            index: +eventModel.id,
            source: null,
            sportId: eventModel.sport.id,
            fixtureId: eventModel.id,
            betBuilderFixtureId,
            market: this.mapMarket(optionMarket),
            name: optionMarket.name.value.replace(/;/g, ' | '),
            event: eventModel,
            marqueeType: MarqueeType.BuildABet,
            showOnHomeLobby: false,
            showOnSportsLobby: false,
            crmPromotionVisibility: VisibilityOnMarquee.MarqueeOnly,
            hideBuildABetBadge: false,
            leftAlignOddsButton: false,
            AwayIndicatorOverride: '',
            BadgeOverrideText: '',
            OverriddenTeamnames: '',
            doNotShowAnyBadgeRibbon: false,
        };
    }

    private mapMarket(optionMarket: OptionMarket): BetBuilderMarket {
        return {
            id: optionMarket.id,
            name: optionMarket.name.value,
            nameSign: '',
            option: this.mapOption(optionMarket.options[0]),
        };
    }

    private mapOption(option: Option): BetBuilderOption {
        return {
            id: option.id,
            optionPrice: {
                id: option.price.id,
                nativePrice: NativePrice.fromNativePrice(option.price),
            },
        };
    }
}
